import React, { useCallback, useEffect, useState } from "react";
import { Joyride, STATUS, ACTIONS } from "react-joyride";
import { useTheme } from "@mui/material/styles";

const tourSteps = [
  {
    target: "#nav-shared-expenses",
    title: "👥 Shared Expenses",
    content:
      "Split bills with friends! When you pay for dinner or a trip, add it here and each friend sees their share automatically. Think of it like Splitwise!",
    skipBeacon: true,
    placement: "bottom",
  },
  {
    target: "#nav-home-expenses",
    title: "🏠 Home Expenses",
    content:
      "Track daily household spending — groceries, rent, electricity. Create a 'Home', add your roommates or family, and everyone can log & view expenses together.",
    skipBeacon: true,
    placement: "bottom",
  },
  {
    target: "#nav-add-friend",
    title: "➕ Add Friends First",
    content:
      "Start by adding friends! Search by name or ID. Once connected, you can split expenses with them or invite them into a Home.",
    skipBeacon: true,
    placement: "bottom",
  },
  {
    target: "#shared-settings-icon",
    title: "⚙️ Manage Shared Groups",
    content:
      "Create expense groups (e.g. 'Goa Trip', 'Flatmates') to organize your shared expenses by occasion or group.",
    skipBeacon: true,
    placement: "bottom",
  },
  {
    target: "#floating-add-buttons",
    title: "➕ Quick Add Expenses",
    content:
      "Tap these buttons anytime to quickly add a shared expense (purple) or a home expense (orange)!",
    skipBeacon: true,
    placement: "top",
  },
];

// Filter out steps whose targets don't exist on the page
const getVisibleSteps = () => {
  return tourSteps.filter((step) => {
    const el = document.querySelector(step.target);
    return el !== null;
  });
};

const GuidedTour = ({ run, onFinish }) => {
  const theme = useTheme();
  const [visibleSteps, setVisibleSteps] = useState([]);

  useEffect(() => {
    if (run) {
      // Small delay to ensure DOM is ready
      const timer = setTimeout(() => {
        setVisibleSteps(getVisibleSteps());
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [run]);

  const handleEvent = useCallback(
    (data) => {
      const { status, action } = data;
      const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

      if (finishedStatuses.includes(status) || action === ACTIONS.CLOSE) {
        onFinish?.();
      }
    },
    [onFinish]
  );

  if (!run || visibleSteps.length === 0) return null;

  return (
    <Joyride
      steps={visibleSteps}
      run={run}
      continuous
      showSkipButton
      showProgress
      scrollToFirstStep
      onEvent={handleEvent}
      locale={{
        back: "Back",
        close: "Close",
        last: "Got it!",
        next: "Next",
        skip: "Skip Tour",
      }}
      options={{
        arrowColor: theme.palette.background.paper,
        backgroundColor: theme.palette.background.paper,
        overlayColor: "rgba(0, 0, 0, 0.6)",
        primaryColor: theme.palette.primary.main,
        textColor: theme.palette.text.primary,
        width: 340,
        zIndex: 10000,
      }}
    />
  );
};

export default GuidedTour;
